import type { Handler, NextFn, RequestContext } from '@ember-data/request';

export const DateAsUTC: Handler = {
  async request<T>(context: RequestContext, next: NextFn<T>) {
    const { content } = await next(context.request);

    return turnAllDateToUtc(content);
  },
};

function turnAllDateToUtc<T>(content: T): T {
  const isArr = Array.isArray(content?.data);
  if (isArr) {
    content?.data.forEach((element) => {
      turnModelAllToUtc(element.attributes);
    });
  } else {
    turnModelAllToUtc(content?.data?.attributes);
  }
  content?.included?.forEach((element) => {
    turnModelAllToUtc(element.attributes);
  });

  return content;
}

function turnModelAllToUtc(attributes) {
  if (attributes.delivery_date) {
    attributes.delivery_date = attributes.delivery_date + 'Z';
  }
  if (attributes.accepted_date) {
    attributes.accepted_date = attributes.accepted_date + 'Z';
  }
  if (attributes.changed_at) {
    attributes.changed_at = attributes.changed_at + 'Z';
  }
  if (attributes.updated_at) {
    attributes.updated_at = attributes.updated_at + 'Z';
  }
  if (attributes.created_at) {
    attributes.created_at = attributes.created_at + 'Z';
  }
}
